import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function RouteWipe() {
  const location = useLocation();

  return (
    <AnimatePresence>
      <motion.div
        key={location.pathname}
        data-testid="route-wipe"
        className="fixed inset-0 z-[90] pointer-events-none"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 0.2 } }}
      >
        <motion.div
          className="absolute inset-0 bg-[#050505]"
          style={{ transformOrigin: "top" }}
          initial={{ scaleY: 1 }}
          animate={{ scaleY: 0 }}
          transition={{ duration: 0.85, ease: EASE, delay: 0.15 }}
        />
        <motion.div
          className="absolute inset-x-0 h-[2px] bg-nc-blue"
          style={{ boxShadow: "0 0 16px rgba(46, 107, 255, 0.6)" }}
          initial={{ top: "100%" }}
          animate={{ top: "0%" }}
          transition={{ duration: 0.85, ease: EASE, delay: 0.15 }}
        />
        <motion.img
          src="/assets/newcitizen-logo-blue.png"
          alt=""
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-auto"
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: [0, 1, 0], scale: [0.94, 1, 1.02] }}
          transition={{ duration: 0.7, times: [0, 0.35, 1], ease: "easeOut" }}
        />
      </motion.div>
    </AnimatePresence>
  );
}
